// Syncs clicking a design thumbnail in the media gallery to the matching
// variant option, so Add to Cart adds the design the customer sees selected.
document.addEventListener('click', function (event) {
  var thumbnailButton = event.target.closest('.thumbnail-list__item .thumbnail');
  if (!thumbnailButton) return;

  var li = thumbnailButton.closest('li[data-variant-option-value]');
  if (!li) return;

  var optionValue = li.getAttribute('data-variant-option-value');
  if (!optionValue) return;

  var gallery = thumbnailButton.closest('media-gallery');
  if (!gallery || !gallery.id) return;

  var sectionId = gallery.id.replace('MediaGallery-', '').replace('-duplicate', '');
  var variantPicker = document.querySelector(
    'variant-radios[data-section="' + sectionId + '"], variant-selects[data-section="' + sectionId + '"]'
  );
  if (!variantPicker) return;

  var radio = Array.prototype.find.call(
    variantPicker.querySelectorAll('input[type="radio"]'),
    function (el) { return el.value === optionValue; }
  );
  if (radio) {
    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }

  var option = Array.prototype.find.call(
    variantPicker.querySelectorAll('select option'),
    function (el) { return el.value === optionValue; }
  );
  if (option) {
    var select = option.closest('select');
    if (select.value !== optionValue) {
      select.value = optionValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});
